// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__38TRj","inputWrap":"styles_inputWrap__3u8j9","input":"styles_input__sdY0A"};